// Architectural summary: Performs a "hard" page refresh equivalent to a manual
// Ctrl+Shift+R: best-effort unregister of any service workers and clear of the
// Cache Storage so the next load pulls fresh HTML/assets, then reloads. Cache
// clearing is best-effort (wrapped in try/catch) — the reload always happens.
export async function hardRefresh(): Promise<void> {
  try {
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    if (typeof caches !== 'undefined') {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch {
    // Best-effort only — never block the reload on cache-clearing failures.
  }
  window.location.reload();
}
